<template lang='pug'>
div
    ServicesSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title Beratung, Schulungen und Untersuchungen
            .subtitle Dienstleistungen im Bereich der Hochspannungstechnik

        div.margin-bottom
            .column-container
                .column.center-content
                    //- Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom-overlay', paginationColor='rgba(255,255,255,0.4)', paginationActiveColor='#FAFAFA', adjustableHeight=false)
                    //-     Slide
                    //-         div.image-container
                    //-             picture
                    img( src='@/assets/svg/Consulting.svg', alt='Beratung, Schulungen und Untersuchungen', title='Beratung, Schulungen und Untersuchungen')
                        //- Slide
                        //-         div.image-container
                        //-             picture
                        //-                 img.carousel-image(src='@/assets/photos/services/acoustical PD localization at transformer 2.jpg')
                .column.factsandbluebox
                    .factbox
                        //- .span.headline Examples:
                        p Wir beraten Sie gerne zu hochspannungstechnischen Fragestellungen und bieten entwicklungsbegleitende Untersuchungen und Analysen an, wie zum Beispiel für
                                ul 
                                    li Spannungsfestigkeit
                                    li Auftreten von Teilentladungen (TE)

                        //- p Seminare und Mitarbeiterschulungen im Bereich der Hochspannungs- und Messtechnik
                        p Wir bieten individuell an Ihren Betrieb angepasste Schulungen und praktische Trainings zu Messtechnik und verschiedenen Diagnoseverfahren an.

                        ul
                            li Messtechnik Grundlagen: Oszilloskop, Tastköpfe, Spektrumsanalysator, Netzwerkanalysator, etc.
                            li Hochspannungstechnik: Erzeugung und Messung hoher Spannungen und Ströme
                            li Teilentladungsdiagnose und -Lokalisierung an Transformatoren und anderen Betriebsmitteln
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        //- Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='Beratung.Schulungen.Untersuchungen', text='Contact Us', size=30, strokeWidth=2)
                        //- Sitelink(to="/de/products/pdm600", text='UHF PD Monitoring System PDM-600')
                        //- Sitelink(to="/de/products/uhfsensors/overview", text='UHF PD Sensors')
        //- div.margin-bottom
            
        //-     h1 Diagnostic Measurements at Transformers
        //-     p We provide different diagnostic measurements for manufacturers and operators of transformers:
        //-     p PD measurement at transformers and other equipment in the test lab or on-site in service using different PD measurement methods:
        //-     ul
        //-         li electrical PD measurement in IEC60270 range and above
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title Consulting, Training and Studies
            .subtitle Services in the field of high-voltage technology

        div.margin-bottom
            .column-container
                .column.center-content
                    //- Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom-overlay', paginationColor='rgba(255,255,255,0.4)', paginationActiveColor='#FAFAFA', adjustableHeight=false)
                    //-     Slide
                    //-         div.image-container
                    //-             picture
                    img( src='@/assets/svg/Consulting.svg', alt='Consulting, Studies and Training', title='Consulting, Studies and Training')
                        //- Slide
                        //-         div.image-container
                        //-             picture
                        //-                 img.carousel-image(src='@/assets/photos/services/acoustical PD localization at transformer 2.jpg')
                .column.factsandbluebox
                    .factbox
                        //- .span.headline Examples:
                        p We provide consulting in high voltage issues and studies accompanying your development to topics such as
                                ul 
                                    li withstand voltage
                                    li partial discharges (PD)
                        //- p Seminars and trainings in the field of high-voltage and measurment technology
                        p We offer customized courses and practical trainings on measurement technology and various diagnostic methods.
                        ul
                            li Measurement Basics: Multimeter, (HV-)probes, oscilloscope, spectrum analyzer, network analyzer, etc.
                            li High-Voltage Technology: Generation and measurement of high voltages and currents
                            li Partial discharge (PD) diagnosis and localization at transformers and other assets
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        //- Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='Consulting.Training.Studies', text='Contact Us', size=30, strokeWidth=2)
                        //- Sitelink(to="/en/products/pdm600", text='UHF PD Monitoring System PDM-600')
                        //- Sitelink(to="/en/products/uhfsensors/overview", text='UHF PD Sensors')
        //- div.margin-bottom
        //-     h1 Diagnostic Measurements at Transformers
        //-     p We provide different diagnostic measurements for manufacturers and operators of transformers:
        //-     p PD measurement at transformers and other equipment in the test lab or on-site in service using different PD measurement methods:
        //-     ul
        //-         li electrical PD measurement in IEC60270 range and above
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
    components: {
        Carousel,
        Slide,
    },
    meta: {
        de: {
            title: "BSS - Dienstleistungen - Beratung, Schulungen und Untersuchungen",
            description:
                "Beratung, Schulungen und Untersuchungen in Bereich der Hochspannungsteschnik und Messtechnik",
        },
        en: {
            title: "BSS - Services - Consulting, Studies and Trainings",
            description:
                "Consulting, Training and Studies in the Field of High-Voltage Technology",
        },
    },
};
</script>

<style lang='sass' scoped>
img
    max-width: 100%

.image-container
    overflow: hidden
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    object-fit: cover
    @media(min-width: $mobile-breakpoint)
        height: 100%
    @media(max-width: $mobile-breakpoint)
        max-height: 200px

    .carousel-image
        margin: 2px
        @media(min-width: $mobile-breakpoint)
            width: 100%
        @media(max-width: $mobile-breakpoint)
            max-height: 200px
</style>